<template>
  <div>
    <div v-if="navs.length > 0" class="nav">
      <label @click="goNav(-1)" class="active">首页</label>
      <label :class="{ active: idx < navs.length - 1 }" @click="goNav(idx)" v-for="(nav, idx) in navs" :key="nav.n">
        > {{ nav.n }}</label>

      <span class="desc">
        <v-icon :size="16" color="orange">info</v-icon>可点击左边<b>蓝色连接</b>可以返回
      </span>
    </div>
    <crud v-if="crudCfg" :cfg="crudCfg" v-show="navs.length == 0" />
    <component v-for="(nav, idx) in navs" :key="nav.n" :is="nav.comp" :cfg="nav.cfg" v-show="idx == navs.length - 1" />
  </div>
</template>
<script>
import { Crud } from "javaee-fre";
const ClazzRuleView = () => import("./clazzrule-view.vue");

export default {
  name: "mo-focus-on-org",
  components: {
    crud: Crud,
  },
  data() {
    return {
      crudCfg: null,
      navs: [],
    };
  },
  methods: {
    goNav(idx) {
      let self = this,
        navs = self.navs;
      idx += 1;
      navs.splice(idx, navs.length - idx);
    },
    onViewClazzRule(rid) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: "培训内容",
        comp: ClazzRuleView,
        cfg: { targetId: rid },
      });
    },
    onClazzStuClick(o, c) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: "培训记录",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/clazzstu",
          params: { _cid: c.id, _oid: o.id },
        },
      });
    },
    onStuClazzClick(a) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: a.name + "的培训记录",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/stuclazz",
          params: { _aid: a.id },
          refreshable: false,
        },
      });
    },
    onStuFaceClick(a) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: a.name + "的人脸采集数据",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/stuface",
          refresh: false,
          params: { _aid: a.id },
          listItemFilter(i, acts) {
            i.img = {
              _component: {
                name: "crud-list-avatar-item",
                cfg: {
                  url: `${self.$const.baseUrl}/home/my/mo/stuface/img/${i.tenantId}/${i.orgId}/${i.clazzId}/${i.accountId}/${i.id}/${i.img}?s=100x100`,
                  previewUrl: `${self.$const.baseUrl}/home/my/mo/stuface/img/${i.tenantId}/${i.orgId}/${i.clazzId}/${i.accountId}/${i.id}/${i.img}`,
                },
              },
            };
            return acts;
          },
        },
      });
    },
    onStuClick(o) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: o.name + "的学员",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/stu",
          countEndding: "名学员",
          params: { _oid: o.id },
          refresh: false,
          listItemActions: [
            {
              label: "人脸",
              icon: "face",
              func(cfg) {
                self.onStuFaceClick(cfg.item);
              },
            },
            {
              label: "培训记录",
              icon: "timeline",
              func(cfg) {
                self.onStuClazzClick(cfg.item);
              },
            },
          ],
        },
      });
    },
    onClazzClick(o) {
      let self = this,
        navs = self.navs;
      navs.push({
        n: o.name + "培训计划",
        comp: Crud,
        cfg: {
          url: "/home/my/mo/clazz",
          params: { _oid: o.id },
          listItemActions: [
            {
              label: "培训记录",
              icon: "group",
              func(cfg) {
                self.onClazzStuClick(o, cfg.item);
              },
            },
            {
              label: "培训计划",
              icon: "details",
              func(cfg) {
                self.onViewClazzRule(cfg.item.ruleId);
              },
            },
          ],
        },
      });
    },
    init() {
      let self = this;
      self.crudCfg = {
        url: "/home/my/mo/org",
        refreshable: false,
        countEndding: "家企业",
        params: {
          _t: "focus",
        },
        listItemActions: [
          {
            label: "取消关注",
            confirm: "确认从重点关注企业中移除吗？",
            icon: "visibility_off",
            func(cfg) {
              let crud = this;
              crud.$axios
                .get(`/home/my/mo/org/update/focus/${cfg.item.id}/false`)
                .then(() => {
                  crud.refresh();
                });
            },
          },
          {
            label: "学员",
            icon: "person",
            func(cfg) {
              self.onStuClick(cfg.item);
            },
          },
          {
            label: "培训计划",
            icon: "schedule",
            func(cfg) {
              self.onClazzClick(cfg.item);
            },
          },
        ],
      };
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.nav {
  padding-bottom: 16px;
  font-size: 10px;
  color: #9e9e9e;
}

.nav label.active {
  cursor: pointer;
  color: #0068b7;
}

.nav .desc {
  float: right;
  color: orange;
}
</style>